import {UnitsType} from "@pg-design/range-module";

import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";
import {RangeOptionNameType} from "../types/RangeOptionNameType";

export const RatingCalculatorRangesOptions: ICalculatorOptions[] = [
    {
        title: "Średnie miesięczne zarobki NETTO [zł]",
        name: RangeOptionNameType.AVERAGE_EARNINGS,
        values: {
            lower: 0,
            upper: 50000,
            init: 5000
        },
        uniteType: UnitsType.NUMBERS,
        step: 500,
        valueType: CalculatorValueType.AVERAGE_EARNINGS,
        allowedInputOverride: 200000
    },
    {
        title: "Miesięczne wydatki domowe",
        name: RangeOptionNameType.HOUSEHOLD_EXPENSES,
        values: {
            lower: 0,
            upper: 15000,
            init: 1000
        },
        uniteType: UnitsType.NUMBERS,
        step: 100,
        valueType: CalculatorValueType.HOUSEHOLD_EXPENSES
    },
    {
        title: "Miesięczne raty kredytów",
        name: RangeOptionNameType.LOAN_INSTALLMENTS,
        values: {
            lower: 0,
            upper: 15000,
            init: 2000
        },
        step: 100,
        uniteType: UnitsType.NUMBERS,
        valueType: CalculatorValueType.LOAN_INSTALLMENTS
    },
    {
        title: "Twój wiek",
        name: RangeOptionNameType.AGE,
        values: {
            lower: 18,
            upper: 65,
            init: 30
        },
        step: 1,
        uniteType: UnitsType.YEARS,
        valueType: CalculatorValueType.AGE
    }
];
import {UnitsType} from "@pg-design/range-module";

import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";
import {RangeOptionNameType} from "../types/RangeOptionNameType";

export const RatingCalculatorRangesOptions: ICalculatorOptions[] = [
    {
        title: "Średnie miesięczne zarobki NETTO [zł]",
        name: RangeOptionNameType.AVERAGE_EARNINGS,
        values: {
            lower: 0,
            upper: 50000,
            init: 5000
        },
        uniteType: UnitsType.NUMBERS,
        step: 500,
        valueType: CalculatorValueType.AVERAGE_EARNINGS,
        allowedInputOverride: 200000
    },
    {
        title: "Miesięczne wydatki domowe",
        name: RangeOptionNameType.HOUSEHOLD_EXPENSES,
        values: {
            lower: 0,
            upper: 15000,
            init: 1000
        },
        uniteType: UnitsType.NUMBERS,
        step: 100,
        valueType: CalculatorValueType.HOUSEHOLD_EXPENSES
    },
    {
        title: "Miesięczne raty kredytów",
        name: RangeOptionNameType.LOAN_INSTALLMENTS,
        values: {
            lower: 0,
            upper: 15000,
            init: 2000
        },
        step: 100,
        uniteType: UnitsType.NUMBERS,
        valueType: CalculatorValueType.LOAN_INSTALLMENTS
    },
    {
        title: "Twój wiek",
        name: RangeOptionNameType.AGE,
        values: {
            lower: 18,
            upper: 65,
            init: 30
        },
        step: 1,
        uniteType: UnitsType.YEARS,
        valueType: CalculatorValueType.AGE
    }
];
